module.exports = {"title":"Historie","cost_value":"Betrag"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/de/history.php
// module id = j07Q
// module chunks = 1